import React from "react";
import { Box, Stack, Typography } from "@curves/ui-base";
import CartItem from "./CartItem";
import { isFunction } from "@util/utils";
import shoppingcart from "@images/shoppingcart2.png";

/**
 *  購物車列表組件
 * @param cartItems - 購物車商品項目陣列
 * @param onRemoveItem - 移除商品項目回調函式
 * @param dialogRef - 對話框參考物件
 * @param onProductClick - 商品點擊回調函式
 * @returns {JSX.Element}
 * @constructor
 */

const CartList = ({ cartItems, onRemoveItem, dialogRef, onEditProduct, showDiscount }) => {
	const handleOpenProductSetting = item => {
		const { openProductSettingDialog } = dialogRef.current || {};
		if (isFunction(openProductSettingDialog) && isFunction(onEditProduct)) {
			openProductSettingDialog(item, onEditProduct);
		}
	};

	return (
		<Box className="pos-cart-list pos-checkout-section">
			{/* 使用陣列渲染商品項目 */}
			{cartItems.length === 0 && (
				<Stack direction="column" justifyContent="center" alignItems="center" spacing={2} style={{ height: "100%", opacity: 0.5 }}>
					<Typography className="mb-0" variant="h6">
						請掃描商品條碼加入購物車
					</Typography>
					<img src={shoppingcart} style={{ width: "200px", marginBottom: "40px" }} alt="請掃描商品條碼加入購物車" />
				</Stack>
			)}
			{cartItems.map((item, index) => (
				<CartItem
					key={item.id}
					item={item}
					sequenceNumber={index + 1}
					isLast={index === cartItems.length - 1}
					onRemove={() => onRemoveItem(item.id)}
					onClickCartItem={handleOpenProductSetting}
					showDiscount={showDiscount}
				/>
			))}
		</Box>
	);
};

export default CartList;
